import { useParams, Link } from "react-router-dom";
import { Product, products } from "../data/products";
import { useState, useEffect } from "react";
import RenderGallery from "components/ImageGallery";
import RevendeurCta from "components/RevendeurCta";

export default function ProductDetail() {
  const { slug } = useParams<{slug:string}>();
  const product: Product | undefined = products.find((p) => p.slug === slug);
  const [imageSrc, setImageSrc] = useState<string>(product?.images?.[0] ?? "")
  useEffect(() => {
    const first = product?.images?.[0] ?? "";
    setImageSrc(first)
  }, [product])
  
  if (!product) {
    return (
      <div>
        Produit introuvable. <Link to="/produits">Retour aux produits</Link>
      </div>
    );
  }

  const {name, images, short, specs, description, revendeurs, ficheTechnique} = product

  return (
    <>
      <nav className="breadcrumbs">
        <Link to="/">Accueil</Link> / <Link to="/produits">Produits</Link> /{" "}
        <span>{name}</span>
      </nav>
      <section className="grid">
        <div className="card" style={{ minHeight: 240 }} aria-label="Image du produit">
          <div>
            <img className="main-picture" src={imageSrc} alt={name} />
          </div>

          <RenderGallery images={images} onSelect={setImageSrc} current={imageSrc} />

        </div>
        <div className="product-desc"> 
          <h1>{name}</h1>
          <p className="color-product-desc">{short}</p>
          <hr />
          <h2>Caractéristiques</h2>
          <ul className="color-product-desc">
            {Object.entries(specs).map(([k, v]) => (
              <li key={k}>
                <strong>{k}:</strong> {String(v)}
              </li>
            ))}
          </ul>
          <hr />
          <RevendeurCta revendeurs= {revendeurs}/>
        </div>
      </section>
      <section style={{ marginTop: 16 }}>
        <h2>Description</h2>
        <p className="color-product-desc">{description}</p>
      </section>
      <section style={{ marginTop: 16 }}>
        <h2>Fiche Technique</h2>
        <p>
          <a href={ficheTechnique} target="_blank" rel="noreferrer noopener">
            Télécharger la fiche technique</a>
          </p>
      </section>
    </>
  );
}
